<template>
  <!--
          作者：luoyiming
          时间：2019-10-24
          描述：后台系统头部
      -->
  <div class="common-header">
    <div class="breadcrumb">
      <!--一般的标题显示-->
      <div class="baseInfo-left-base d-s-c">
        <span class="name">{{ menu_title }}</span>
        <!--插件切换-->
        <div class="el-tabs-container">
          <el-tabs v-model="activeValue" @tab-click="tabClick">
            <el-tab-pane :label="item.value" :name="item.key" v-for="(item, index) in tabList"
                         :key="index"></el-tab-pane>
          </el-tabs>
        </div>
      </div>

      <div class="header-navbar">
        <div class="header-navbar-icon">
          <!--          <span class="gray">当前版本：{{baseInfo.version}}</span>-->
          <span class="p-10-0 blue fb tc f16">{{ baseInfo.shop_name }}</span>
        </div>
        <div class="header-navbar-icon"><span class="gray"
                                              v-if="baseInfo.storeType === 10 && baseInfo.wxQrCode">|</span></div>
        <div class="header-navbar-icon" @click="onWxQrCodeClick()"
             v-if="baseInfo.storeType === 10 && baseInfo.wxQrCode">店铺小程序码
        </div>
        <div class="header-navbar-icon"><span class="gray"
                                              v-if="baseInfo.storeType === 10 && baseInfo.wxUrlLink">|</span></div>
        <div class="header-navbar-icon" @click="showWxUrlLink()"
             v-if="baseInfo.storeType === 10 && baseInfo.wxUrlLink">店铺分享码
        </div>
        <div class="header-navbar-icon"><span class="gray">|</span></div>
        <div class="header-navbar-icon">
          <span class="icon iconfont icon-geren9"></span>
          <span class="text ml4 blue">{{ baseInfo.user.userName }}，欢迎您！</span>
        </div>
        <div class="header-navbar-icon"><span class="gray">|</span></div>
        <div class="header-navbar-icon" @click="onMsgClick">
          <el-badge :value="unReadMsgNum" :hidden="unReadMsgNum<1">
            <i class="el-icon-bell fs-16"></i>
          </el-badge>
        </div>
        <div class="header-navbar-icon"><span class="gray">|</span></div>
        <div class="header-navbar-icon" @click="passwordFunc()"><span class="text">修改密码</span></div>
        <div class="header-navbar-icon login-out" @click="login_out()">
          <span class="icon iconfont icon-tuichu"></span>
          <span class="text ml4">退出</span>
        </div>
      </div>
    </div>

    <!--修改密码-->
    <UpdatePassword v-if="is_password" @close="closeFunc"></UpdatePassword>

    <el-dialog
      :title="supplierName + '二维码'" :close-on-click-modal="false"
      :visible.sync="showQrCode"
      center
      width="550px"
    >
      <div
        style="border: 1px solid #D1D2D3;margin-top: -20px;display: flex;justify-content: center;align-items: center">
        <div
          style="width:90%;flex-shrink: 0;display: flex;flex-direction: column;justify-content: center;align-items: center">
          <img :src="supplieQrcode" alt="" class="" ref="poster"
               style="width: 360px; height: 540px;margin-top: 20px"
          >
          <div
            @click="onQrcodeDownload"
            style="margin-top:20px;margin-bottom: 30px;width: 143px;height:33px ;border-radius: 3px;border:1px solid #67B3FF;background-color:#E6F1FC;cursor: pointer;display: flex;justify-content: center;align-items: center"
          >
            <img alt="" src="../../assets/common/ic_xiazai@2x.png"
                 style="width:15px;height: 14px;"
            >
            <div style="color:#1989FA;font-size: 14px;margin-left: 5px">
              立即下载
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :title="supplierName + '分享码'" :close-on-click-modal="false"
      :visible.sync="showWxUrl"
      center
      width="550px"
    >
      <el-input v-model="wxUrlLink" readonly>
        <template slot="append"><span v-clipboard:copy="wxUrlLink" v-clipboard:success="copy"
                                      v-clipboard:error="onerror" style="cursor: pointer">复制</span></template>
      </el-input>
      <div class="margin-top-30 flex a-center j-center">
        <el-button @click="onWxUrlGet()">重新获取</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import bus from '@/utils/eventBus.js'
import UserApi from '@/api/user.js'
import html2canvas from 'html2canvas'
import FileSaver from 'file-saver'
import OrderApi from '@/api/order.js'
import AgentApi from '@/api/agent.js'

import {delCookie, deleteSessionStorage} from '@/utils/base.js'
import UpdatePassword from './part/UpdatePassword.vue'

export default {
  components: {
    UpdatePassword
  },
  data () {
    return {
      /*菜单名称*/
      menu_title: '菜单',
      /*切换菜单*/
      tabList: [],
      /*切换选中*/
      activeValue: 0,
      /*是否修改密码*/
      is_password: false,
      /*tab切换类别*/
      tab_type: '',
      showQrCode: false,                        //显示企业码
      supplierName: '',
      supplieQrcode: '',
      interTime: null,
      unReadMsgNum: 0,
      showWxUrl: false,
      wxUrlLink: ''
    }
  },
  inject: ['baseInfo'],
  created () {
    /*监听菜单传过来的值*/
    bus.$on('menuName', res => {
      this.menu_title = res
    })

    /*监听传插件的值*/
    bus.$on('tabData', res => {
      this.tabList = res.list
      this.activeValue = res.active
      this.tab_type = res.tab_type
    })

    bus.$on('unReadMessage', res => {
      let self = this
      OrderApi.getRefundMsg({}, true).then(result => {
        self.unReadMsgNum = result.data || 0
      })
    })

    //发送给其它组件头部加载完成
    bus.$emit('headLoad', true)

  },
  beforeDestroy () {
    bus.$off('menuName')
    bus.$off('tabData')
    bus.$off('unReadMessage')
    clearInterval(this.interTime)
    this.interTime = null
  },
  mounted () {
    bus.$emit('unReadMessage')
    this.interTime = setInterval(() => {
      bus.$emit('unReadMessage')
    }, 1000 * 60 * 1)
  },
  methods: {

    /*退出登录*/
    login_out () {
      this.$confirm('此操作将退出登录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          UserApi.loginOut({}, true)
            .then(data => {
              /*删除登录状态*/
              delCookie('isLogin_supplier')
              /*删除基本信息*/
              delCookie('baseInfo_supplier')
              /*删除用户菜单*/
              deleteSessionStorage('rolelist_supplier')
              /*删除用户权限*/
              deleteSessionStorage('authlist_supplier')
              /*删除用户权限*/
              deleteSessionStorage('token_supplier')
              /*返回登录页*/
              this.$router.replace({
                path: '/login'
              })
              /*删除stores数据*/
              this.$store.commit('user/setState', {
                key: 'roles',
                val: null
              })
              /*刷新页面*/
              location.reload()
            })
            .catch(error => {
            })
        })
        .catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消退出'
          // });
        })
    },

    /*点击跳转*/
    tabClick (e) {
      /*优惠券*/
      if (this.tab_type == 'coupon') {
        this.$router.push({
          path: '/operate/coupon/index',
          query: {
            type: e.name
          }
        })
      }
      /*广告*/
      if (this.tab_type == 'ad') {
        this.$router.push({
          path: '/operate/ad/index',
          query: {
            type: e.name
          }
        })
      }
      /*拼团*/
      if (this.tab_type == 'assemble') {
        this.$router.push({
          path: '/activity/assemble/index',
          query: {
            type: e.name
          }
        })
      }
      /*秒杀*/
      if (this.tab_type == 'seckill') {
        this.$router.push({
          path: '/activity/seckill/index',
          query: {
            type: e.name
          }
        })
      }
      /*砍价*/
      if (this.tab_type == 'bargain') {
        this.$router.push({
          path: '/activity/bargain/index',
          query: {
            type: e.name
          }
        })
      }


      bus.$emit('activeValue', this.activeValue)
    },
    onMsgClick () {
      if (this.$route.path !== '/order/refund/index') {
        this.$router.push({
          path: '/order/refund/index'
        })
      }
    },
    /*修改密码*/
    passwordFunc () {
      this.is_password = true
    },

    /*关闭修改密码*/
    closeFunc () {
      this.is_password = false
    },

    onWxQrCodeClick () {
      this.supplieQrcode = this.baseInfo.wxQrCode
      this.supplierName = this.baseInfo.shop_name || ''
      this.showQrCode = true
    },

    async onQrcodeDownload () {
      if (this.supplieQrcode) {
        const opts = {
          useCORS: true,
          scale: 2
        }
        const canvas = await html2canvas(this.$refs.poster, opts)
        canvas.toBlob(blob => {
          FileSaver.saveAs(blob, this.supplierName + '.png')
        })
      }
    },
    copy () {
      this.$message.info('复制成功')
    },
    onerror () {
      this.$message.info('复制失败')
    },
    showWxUrlLink () {
      this.supplierName = this.baseInfo.shop_name || ''
      this.wxUrlLink = this.baseInfo.wxUrlLink || ''
      this.showWxUrl = true
    },
    onWxUrlGet () {
      AgentApi.getRefreshWxUrl({}, true).then(res => {
        this.wxUrlLink = res.data
        bus.$emit('angentChange')
        this.$message.info('重新获取成功')
      })
    },
  }
}
</script>

<style lang="scss">
.common-header .el-tabs__nav-wrap::after {
  display: none;
}

.common-header .el-tabs-container {
  margin-left: 20px;
  padding-left: 20px;
  border-left: 1px solid #EEEEEE;
}

.common-header .el-tabs__header {
  margin-bottom: 0;
}

.login-out .icon-tuichu {
  color: red;
}

.header-navbar-icon .icon-geren9 {
  font-size: 20px;
}

.el-badge__content.is-fixed {
  top: 15px
}
</style>



// WEBPACK FOOTER //
// src/views/layout/Head.vue